import { useQuery } from 'react-query';
import { PROJECT_ID } from '../constants';
export const useAuthData = ({ httpClient, authUrl, configurationId }) => {
    const { refetch, ...authDataQuery } = useQuery({
        queryKey: ['auth-url', configurationId],
        queryFn: () => {
            return httpClient(`${authUrl}/user/authentications`, {
                method: 'get',
                traceId: `${PROJECT_ID}-2`
            });
        },
        enabled: false,
        select: (data) => {
            var _a;
            const authEntries = ((_a = data === null || data === void 0 ? void 0 : data.value) !== null && _a !== void 0 ? _a : []).reduce((acc, authEntry) => {
                const appId = authEntry.configurationId;
                return {
                    ...acc,
                    [appId]: authEntry.credentialsId
                };
            }, {});
            return authEntries;
        },
        initialData: {}
    });
    return {
        ...authDataQuery,
        fetch: refetch
    };
};
